<template>
  <div></div>
</template>

<script>
export default {
  components: {},
  props: [],
  data () {
    return {}
  },
  beforeCreate () {},
  created () {},
  beforeMount () {},
  mounted () {
    this.$router.replace('/Login')
  },
  beforeUpdate () {},
  updated () {},
  beforeDestroy () {},
  destroyed () {},
  watch: {},
  computed: {},
  methods: {}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Landing.vue